module.exports = __webpack_public_path__ + "media/images/mute-icon-62d41abff72108e4e1ad32517b5d0171.svg";